import React from 'react';
import PropTypes from 'prop-types';
import { Subtitle2Stronger, Body1 } from '@fluentui/react-components';
import { LockClosed24Regular } from '@fluentui/react-icons';
import { MODULE_LABELS, SUPPORT_EMAIL } from 'constants.js';
import './style.scss';

const ModuleDisabled = ({ module, isAdmin = false }) => {
    const label = MODULE_LABELS[module] ?? 'This module';
    const description = isAdmin
        ? `${label} is currently disabled for your organisation. Please connect with the EngageWith support team at ${SUPPORT_EMAIL} to enable it.`
        : `${label} is currently disabled for your organisation. Please connect with your EngageWith admin to enable it.`;

    return (
        <div className='module-disabled-container' data-testid='module-disabled'>
            <LockClosed24Regular />
            <Subtitle2Stronger>{`${label} is disabled`}</Subtitle2Stronger>
            <Body1 className='module-disabled-description'>{description}</Body1>
        </div>
    );
};

ModuleDisabled.propTypes = {
    module: PropTypes.string,
    isAdmin: PropTypes.bool,
};

export default ModuleDisabled;
